import * as React from 'react';

type LeftDebugChatPanelProps = {
    opened: boolean
    children: React.ReactChild
    className?: string
}
function LeftDebugChatPanel({ opened, children, className = '' }: LeftDebugChatPanelProps) {
    return (
        <div className={`overlay-click-wrapper left-debug-chat-panel ${className} ${opened && 'opened'}`}>
            {children}
        </div>
    );
}
export default LeftDebugChatPanel;